import BASEURLGESTTOR from '../api/gesttor'

export function tarefasAtrasadas () {
    return BASEURLGESTTOR.get ('/tarefas/atrasadas')
}

export function tarefasPendentes () {
    return BASEURLGESTTOR.get ('/tarefas/pendentes')
}

export function chamadosPendentes () {
    return BASEURLGESTTOR.get ('/chamados/pendentes')
}

export function atendimentosPendentes () {
    return BASEURLGESTTOR.get ('/atendimentos/pendentes')
}

export function ultimosAtendimentos () {
    return BASEURLGESTTOR.get ('/tarefas/finalizadas')
}

export function Produtividade () {
    return BASEURLGESTTOR.get ('/tarefas/produtividade')
}

export function npsAtendimento () {
    return BASEURLGESTTOR.get ('/nps/atendimento')
}
